import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import BlankImg from "assets/images/SVG/no-data-home.svg";

const FullScreenImageModel = ({
  imgSrc,
  placeholder = BlankImg,
  style,
  fullScreen = false,
  alt = "image",
}) => {
  const [error, setError] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Lock body scroll
  useEffect(() => {
    document.body.style.overflow = isModalOpen ? "hidden" : "auto";
  }, [isModalOpen]);

  // Close modal on ESC key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isModalOpen) {
        setModalOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isModalOpen]);

  const toggleModal = (imageSrc) => {
    if (fullScreen && !error) {
      setSelectedImage(imageSrc);
      setModalOpen((prev) => !prev);
    }
  };

  const modalContent = (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999999,
        backgroundColor: "rgba(0,0,0,0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
      onClick={() => setModalOpen(false)}
    >
      <img
        src={selectedImage}
        alt=""
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          borderRadius: "8px",
        }}
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );

  return (
    <>
      <img
        src={imgSrc ? (error ? placeholder : imgSrc) : placeholder}
        onError={() => setError(true)}
        className={
          imgSrc ? (error ? "img-contain" : "img-cover") : "img-contain"
        }
        style={{ ...style, cursor: fullScreen ? "pointer" : "unset" }}
        alt={alt}
        onClick={() =>
          toggleModal(imgSrc ? (error ? placeholder : imgSrc) : placeholder)
        }
      />

      {fullScreen &&
        isModalOpen &&
        selectedImage &&
        ReactDOM.createPortal(modalContent, document.body)}
    </>
  );
};

export default FullScreenImageModel;
